var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 150 150",
    fill: "#025add",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m65.583 134.665a50.25 50.25 0 1 1 50.25-50.25 50.307 50.307 0 0 1 -50.25 50.25zm0-98.5a48.25 48.25 0 1 0 48.25 48.25 48.305 48.305 0 0 0 -48.25-48.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m65.583 123.832a39.417 39.417 0 1 1 39.417-39.416 39.461 39.461 0 0 1 -39.417 39.416zm0-76.834a37.417 37.417 0 1 0 37.417 37.418 37.46 37.46 0 0 0 -37.417-37.416z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m65.583 113a28.584 28.584 0 1 1 28.584-28.584 28.616 28.616 0 0 1 -28.584 28.584zm0-55.167a26.584 26.584 0 1 0 26.584 26.583 26.613 26.613 0 0 0 -26.584-26.584z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m65.583 102.165a17.75 17.75 0 1 1 17.75-17.749 17.77 17.77 0 0 1 -17.75 17.749zm0-33.5a15.75 15.75 0 1 0 15.75 15.751 15.769 15.769 0 0 0 -15.75-15.751z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m65.583 41.5a1 1 0 0 1 -1-1v-10.668a1 1 0 1 1 2 0v10.668a1 1 0 0 1 -1 1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m65.583 140a1 1 0 0 1 -1-1v-10.668a1 1 0 0 1 2 0v10.668a1 1 0 0 1 -1 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m120.167 85.415h-10.667a1 1 0 0 1 0-2h10.667a1 1 0 0 1 0 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m21.667 85.415h-10.667a1 1 0 0 1 0-2h10.667a1 1 0 0 1 0 2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m132.744 18.538a1 1 0 0 1 -.706-1.709l6.256-6.229a1 1 0 0 1 1.412 1.418l-6.257 6.229a1 1 0 0 1 -.705.291z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m65.589 85.421a1 1 0 0 1 -.7-1.708l55.264-55.048a1 1 0 0 1 1.412 1.417l-55.265 55.048a1 1 0 0 1 -.711.291z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m127.273 31.812a1 1 0 0 1 -.218-.024l-6.493-1.453a1 1 0 0 1 -.752-.731l-1.631-6.451a1 1 0 0 1 .253-.942l11.583-11.911a1 1 0 0 1 1.686.452l1.481 5.855 5.893 1.319a1 1 0 0 1 .5 1.673l-11.585 11.91a1 1 0 0 1 -.717.303zm-5.674-3.3 5.347 1.2 9.946-10.223-4.747-1.063a1 1 0 0 1 -.751-.731l-1.194-4.714-9.945 10.219z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSocial);
export default __webpack_public_path__ + "static/media/service-social.01169967b5269a35b4aca9d03e9fc151.svg";
export { ForwardRef as ReactComponent };